var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftCards = function SvgGiftCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "gift-cards_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".gift-cards_svg__cls-2{stroke-width:0;fill:#fd0}"))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h500v500H0z",
    style: {
      strokeWidth: 0,
      fill: "#0054a6"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.05 225.87c-28.42 0-43.77-15.19-48.28-20.54-8.64-10.24-11.6-22.26-7.92-32.15 3.28-8.82 11.34-14.66 22.68-16.46 10.68-1.69 20.35.61 28.75 6.85 21.28 15.8 26.44 51.88 26.65 53.4l.84 6.12-6.07 1.15c-5.98 1.13-11.53 1.63-16.66 1.63Zm-26.89-56.68c-1.49 0-3.01.13-4.59.38-4.61.73-10.52 2.74-12.54 8.16-1.99 5.35.18 12.72 5.67 19.23 3.89 4.61 18.14 18.52 46.13 15.48-2.26-10.02-8.05-29.35-20.32-38.44-4.34-3.22-9.07-4.81-14.35-4.81",
    className: "gift-cards_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.44 261.03c-2.92 0-5.58-1.98-6.31-4.95-.86-3.48 1.27-7 4.75-7.86.31-.08 31.2-8.04 40.58-31.27a6.49 6.49 0 0 1 8.46-3.59 6.49 6.49 0 0 1 3.59 8.46c-11.89 29.45-47.98 38.64-49.51 39.02-.52.13-1.04.19-1.56.19",
    className: "gift-cards_svg__cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.43 225.98c-5.27 0-11-.53-17.19-1.74l-6.06-1.19.88-6.11c.22-1.53 5.62-37.56 27.01-53.22 8.44-6.18 18.13-8.42 28.8-6.65 11.33 1.88 19.35 7.78 22.57 16.62 3.61 9.91.57 21.91-8.14 32.09-4.52 5.28-19.81 20.2-47.87 20.2m-8.24-13.49c27.97 3.23 42.31-10.58 46.24-15.17 5.54-6.47 7.76-13.83 5.81-19.19-1.98-5.43-7.88-7.48-12.48-8.24-7.18-1.19-13.39.22-18.98 4.3-12.33 9.01-18.25 28.3-20.58 38.3Z",
    className: "gift-cards_svg__cls-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M382.29 261.34c-.53 0-1.07-.06-1.6-.2-1.53-.39-37.55-9.83-49.25-39.36-1.32-3.34.31-7.12 3.65-8.44s7.11.31 8.44 3.65c9.22 23.29 40.06 31.47 40.37 31.55 3.47.89 5.57 4.43 4.68 7.91a6.494 6.494 0 0 1-6.29 4.89",
    className: "gift-cards_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.94 133.45c9.94 0 18 8.06 18 18v197.11c0 9.94-8.06 18-18 18H89.06c-9.94 0-18-8.06-18-18V151.45c0-9.94 8.06-18 18-18h321.89m0-13H89.06c-17.09 0-31 13.91-31 31v197.11c0 17.09 13.91 31 31 31h321.89c17.09 0 31-13.91 31-31V151.45c0-17.09-13.91-31-31-31",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.06 212.19h357.89v13H71.06z",
    className: "gift-cards_svg__cls-2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M331.12 133.45h13v233.11h-13z",
    className: "gift-cards_svg__cls-2"
  })));
};
export default SvgGiftCards;